import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "tw-relative tw-flex tw-items-center tw-gap-2" }
const _hoisted_2 = { class: "tw-text-2xs" }
const _hoisted_3 = { key: 0 }

import { ref, computed } from 'vue';

import { VideoAsset } from '../videoLibraryService';

import TablerAlertTriangle from '@/studioComponents/Icons/tabler/TablerAlertTriangle.vue';
import StudioAlertBanner from '@/studioComponents/StudioAlertBanner.vue';
import TooltipPopup from '@/studioComponents/TooltipPopup.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoLibraryTableStatusCell',
  props: {
    videoAsset: {},
    tooltipPosition: {}
  },
  setup(__props: any) {

const props = __props;



const showTooltip = ref(false);

const hasIssues = computed(() => {
  if (!props.videoAsset.errors.length && !props.videoAsset.warnings.length) {
    return null;
  }

  return props.videoAsset.errors.length > 0 ? 'error' : 'warning';
});

const statusConfig = computed(() => {
  const statusMap = {
    SUBMITTED: {
      title: 'Pending',
      colorVariant: 'gray',
      tooltipText: ''
    },
    PROGRESSING: {
      title: 'Processing',
      colorVariant: 'gray',
      tooltipText: ''
    },
    PROCESSING_HD: {
      title: 'Processing HD',
      colorVariant: 'yellow',
      tooltipText: "We're optimizing the HD version in the background to ensure smoother playback in events."
    },
    COMPLETE: {
      title: 'Completed',
      colorVariant: 'green',
      tooltipText: ''
    },
    ERROR: {
      title: 'Error',
      colorVariant: 'red',
      tooltipText: ''
    },
    READY_TO_PUBLISH: {
      title: 'Ready to be Published',
      colorVariant: 'gray',
      tooltipText: ''
    }
  };

  return (
    statusMap[props.videoAsset.status] || {
      title: 'Unknown',
      colorVariant: 'gray',
      tooltipText: ''
    }
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TooltipPopup, { position: _ctx.tooltipPosition }, _createSlots({
      trigger: _withCtx(() => [
        _createElementVNode("span", {
          class: _normalizeClass(["tw-inline-flex tw-h-fit tw-w-fit tw-items-center tw-space-x-1 tw-rounded-full tw-px-2 tw-py-1 tw-text-center tw-font-medium", {
            'tw-bg-green-50 tw-text-green-600': statusConfig.value.colorVariant === 'green',
            'tw-bg-gray-50 tw-text-gray-600': statusConfig.value.colorVariant === 'gray',
            'tw-bg-red-50 tw-text-red-600': statusConfig.value.colorVariant === 'red',
            'tw-bg-yellow-50 tw-text-yellow-600': statusConfig.value.colorVariant === 'yellow'
          }])
        }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(statusConfig.value.title), 1)
        ], 2)
      ]),
      _: 2
    }, [
      (statusConfig.value.tooltipText)
        ? {
            name: "content",
            fn: _withCtx(() => [
              _createTextVNode(_toDisplayString(statusConfig.value.tooltipText), 1)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["position"]),
    (hasIssues.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(TablerAlertTriangle, {
            "data-testid": "alert-triangle-icon",
            class: _normalizeClass({
          'tw-mb-0.5 tw-h-4 tw-w-4': true,
          'tw-text-amber-500': hasIssues.value === 'warning',
          'tw-text-red-500': hasIssues.value === 'error'
        }),
            onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (showTooltip.value = true)),
            onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (showTooltip.value = false))
          }, null, 8, ["class"]),
          _createVNode(_Transition, {
            enterActiveClass: "tw-transition tw-duration-200 tw-ease-out",
            enterFromClass: "tw-transform tw-scale-95 tw-opacity-0",
            enterToClass: "tw-transform tw-scale-100 tw-opacity-100",
            leaveActiveClass: "tw-transition tw-duration-150 tw-ease-in",
            leaveFromClass: "tw-transform tw-scale-100 tw-opacity-100",
            leaveToClass: "tw-transform tw-scale-95 tw-opacity-0"
          }, {
            default: _withCtx(() => [
              (showTooltip.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass({
            'tw-absolute tw-left-1/2 tw-z-50 tw-w-72 tw--translate-x-1/2 tw-rounded-md tw-bg-white tw-p-3 tw-shadow-lg': true,
            'tw-top-8': _ctx.tooltipPosition === 'bottom',
            'tw-bottom-8': _ctx.tooltipPosition === 'top'
          }),
                    onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (showTooltip.value = true)),
                    onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (showTooltip.value = false))
                  }, [
                    (_ctx.videoAsset.errors.length > 0)
                      ? (_openBlock(), _createBlock(StudioAlertBanner, {
                          key: 0,
                          type: "error",
                          class: "tw-mb-2"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videoAsset.errors, (error) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: error,
                                class: "tw-mb-1"
                              }, _toDisplayString(error), 1))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.videoAsset.warnings.length > 0)
                      ? (_openBlock(), _createBlock(StudioAlertBanner, {
                          key: 1,
                          type: "warning"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videoAsset.warnings, (warning) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: warning,
                                class: "tw-mb-1"
                              }, _toDisplayString(warning), 1))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ], 34))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})